import { txt } from '../utils/dom.js';
import { hexToRgb, getLuminance, safe } from '../utils/contrast.js';

    export const faqBlock = (rawProps, index = 0) => {
        const p = safe(rawProps);
        const variant = p.variant || 'v1';

        // 1. CÁLCULO DE CONTRASTE INTELIGENTE PARA LOS BOTONES
        const isDark = getLuminance(...hexToRgb(p.bgColor)) < 0.179;
        const btnBg = isDark ? "#ffffff" : "#111827";
        const btnIcon = isDark ? "#111827" : "#ffffff";

        // --- Toolbar de cada item (compartida por todas las variantes) ---
        const itemTools = (i, direction = 'vertical') => {
            const addTop = direction === 'vertical'
                ? (i !== 0 ? `<button class="item-add-btn card-add-top" data-array="items" data-index="${i}">+</button>` : '')
                : (i !== 0 ? `<button class="item-add-btn card-add-left" data-array="items" data-index="${i}">+</button>` : '');
            const addBottom = direction === 'vertical'
                ? `<button class="item-add-btn card-add-bottom" data-array="items" data-index="${i}">+</button>`
                : `<button class="item-add-btn card-add-right" data-array="items" data-index="${i}">+</button>`;
            return `
            ${addTop}
            ${addBottom}
            <div class="item-tools">
                <button class="tool-btn item-drag-handle" title="Mover" style="background: ${btnBg} !important; color: ${btnIcon} !important;">${window.icons.drag}</button>
                <button class="tool-btn item-delete-btn" data-array="items" data-index="${i}" title="Borrar" style="background: ${btnBg} !important; color: ${btnIcon} !important;">${window.icons.trash}</button>
            </div>`;
        };

        // --- v1 (actual): border-left accent + hover translateX ---
        if (variant === 'v1' || (!variant || variant === '')) {
            return `
        <section id="bloque-faq" class="reveal variant-${variant}" style="--bg:${p.bgColor}; --text:${p.textColor}; --accent:${p.accentColor}; --font:'${p.fontFamily || "Inter"}'; padding: 120px 8%; overflow: visible;">
          <h2 data-field="title" contenteditable="true" style="text-align: center; margin-bottom: 70px;">${p.title || 'Preguntas Frecuentes'}</h2>
          
          <div style="max-width: 900px; margin: 0 auto; display: flex; flex-direction: column; gap: 25px;">
            ${p.items.map((item, i) => `
              <div class="faq-card sortable-item" data-item-index="${i}" data-array-name="items"
                   style="background: var(--card-bg, color-mix(in srgb, var(--text) 3%, transparent)); border-left: 5px solid var(--accent); padding: 35px; border-radius: var(--card-radius, 16px); transition: background 0.3s, transform 0.3s; position: relative;"
              >
                ${itemTools(i)}
                <h3 data-field="name" contenteditable="true" style="font-size: calc(1.4rem * var(--heading-scale, var(--u-type-scale, 1))); margin-bottom: 15px; font-weight: 700; color: inherit; padding-right: 80px; word-break: break-word;">${txt(item.name)}</h3>
                <p data-field="desc" contenteditable="true" style="opacity: 0.7; line-height: 1.8; font-size: calc(1.1rem * var(--text-scale, 1)); border-top: 1px solid color-mix(in srgb, var(--text) 10%, transparent); padding-top: 15px; word-break: break-word;">${txt(item.desc)}</p>
              </div>
            `).join('')}
          </div>
        </section>`;
        }

        // --- v2 ("minimal"): sin fondo, separación por línea horizontal, limpio y aireado ---
        if (variant === 'v2') {
            return `
        <section id="bloque-faq" class="reveal variant-${variant}" style="--bg:${p.bgColor}; --text:${p.textColor}; --accent:${p.accentColor}; --font:'${p.fontFamily || "Inter"}'; padding: 120px 8%; overflow: visible;">
          <h2 data-field="title" contenteditable="true" style="text-align: center; margin-bottom: 70px;">${p.title || 'Preguntas Frecuentes'}</h2>
          
          <div style="max-width: 800px; margin: 0 auto; display: flex; flex-direction: column;">
            ${p.items.map((item, i) => `
              <div class="faq-card sortable-item" data-item-index="${i}" data-array-name="items"
                   style="padding: 35px 0 35px 60px; border-bottom: 1px solid color-mix(in srgb, var(--text) 8%, transparent); position: relative;">
                ${itemTools(i)}
                <span class="ghost-number" aria-hidden="true" style="font-size: 2.5rem; top: 30px; left: 0; opacity: 0.15;">0${i + 1}</span>
                <h3 data-field="name" contenteditable="true" style="font-size: calc(1.3rem * var(--heading-scale, var(--u-type-scale, 1))); margin-bottom: 12px; font-weight: 800; color: inherit; padding-right: 80px; word-break: break-word;">${txt(item.name)}</h3>
                <p data-field="desc" contenteditable="true" style="opacity: 0.6; line-height: 1.8; font-size: calc(1.05rem * var(--text-scale, 1)); font-weight: 400; word-break: break-word;">${txt(item.desc)}</p>
              </div>
            `).join('')}
          </div>
        </section>`;
        }

        // --- v3 ("cards") y v4 ("acordeón glass"): MISMO esqueleto de tarjetas ---
        // v3 = grid de 2 columnas; v4 lo lleva a columna única glass desde css/site.css.
        // Lo que v4 añade aquí es la semántica de ACORDEÓN, porque su etiqueta lo promete:
        // la pregunta pasa a ser el disparador (role=button + aria-expanded + aria-controls)
        // y la respuesta vive en un panel plegable (.faq-a), que el CSS colapsa.
        // El plegado lo cablea core/block-actions.js por DELEGACIÓN DE CLASE: NADA de `on*`
        // inline, que el saneo XSS del sitio publicado los borra (gotcha nº13).
        // En el canvas de edición (.editor-active) el CSS deja TODO abierto y el handler no
        // hace nada → la edición inline de los contenteditable no se rompe.
        const acordeon = variant === 'v4';
        return `
        <section id="bloque-faq" class="reveal variant-${variant}" style="--bg:${p.bgColor}; --text:${p.textColor}; --accent:${p.accentColor}; --font:'${p.fontFamily || "Inter"}'; padding: 120px 8%; overflow: visible;">
          <h2 data-field="title" contenteditable="true" style="text-align: center; margin-bottom: 70px;">${p.title || 'Preguntas Frecuentes'}</h2>

          <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(min(100%, 380px), 1fr)); gap: 24px; max-width: 1100px; margin: 0 auto;">
            ${p.items.map((item, i) => {
              // La 1ª respuesta nace abierta: enseña que debajo de cada pregunta hay algo.
              const abierta = acordeon && i === 0;
              const idQ = `faq-q-${index}-${i}`;
              const idA = `faq-a-${index}-${i}`;
              const attrsQ = acordeon
                ? ` class="faq-q" id="${idQ}" role="button" tabindex="0" aria-expanded="${abierta ? 'true' : 'false'}" aria-controls="${idA}"`
                : '';
              const respuesta = `<p data-field="desc" contenteditable="true" style="opacity: 0.65; line-height: 1.7; font-size: calc(1rem * var(--text-scale, 1)); word-break: break-word;">${txt(item.desc)}</p>`;
              return `
              <div class="card faq-card sortable-item${acordeon ? ' faq-collapsible' : ''}${abierta ? ' is-open' : ''}" data-item-index="${i}" data-array-name="items"
                   style="padding: 36px 32px; position: relative;">
                ${itemTools(i, 'horizontal')}
                <h3${attrsQ} style="font-size: calc(1.2rem * var(--heading-scale, var(--u-type-scale, 1))); margin-bottom: 14px; font-weight: 700; color: inherit; padding-right: 60px; word-break: break-word; display: flex; align-items: flex-start; gap: 10px;">
                  <span style="color: var(--accent); font-size: calc(1.4rem * var(--heading-scale, var(--u-type-scale, 1))); line-height: 1; flex-shrink: 0;" aria-hidden="true">›</span>
                  <span data-field="name" contenteditable="true">${txt(item.name)}</span>
                </h3>
                ${acordeon
                  ? `<div class="faq-a" id="${idA}" role="region" aria-labelledby="${idQ}">${respuesta}</div>`
                  : respuesta}
              </div>`;
            }).join('')}
          </div>
        </section>`;
    }
